import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Регистрация платежа
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Payment/f5610719af05925870dc02555a45b38d
*
*/
export const makePaymentAuth = (providerId: number, params = {}): IRequest => ({
    uri: '/payment/add',
    withAuth: true,
    withProvider: true,
    method: 'POST',
    body: JSON.stringify(params),
    queryParams: {
        providerId,
    },
});

/*
* Простая оплата без токена по timestamp и client_secret
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/UnauthPayment/2daace48edd50f86130bdbe7fc5cd644
*/
export const makePaymentUnauth = (providerId: number, params = {}): IRequest => ({
    uri: '/unauth-payment/add',
    method: 'POST',
    body: JSON.stringify(params),
    queryParams: {
        providerId,
    },
});
